import script from "./TextPreloader.vue?vue&type=script&setup=true&lang=ts"
export * from "./TextPreloader.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__